import React from "react";
import { Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { DevForm } from "@components/Forms/Fields";
import { useSubmit } from "@components/Forms/Handlers";
import { RenderForm } from "@components/Forms/Render";
import { Awesome, YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { CountriesBareForm, CountriesPresets } from "@components/Screen/CountryBlocks";
import { url_reverse } from "@components/Utils";

export default function TagScreen({ screen }) {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Теги");
    let body = null;
    if (params.id) {
        if (screen === "games") {
            body = <Games id={params.id} header={header} />;
        } else if (screen === "countries") {
            body = <Countries id={params.id} header={header} />;
        } else {
            body = <Edit id={params.id} header={header} />;
        }
    } else {
        body = <List header={header} />;
    }
    return <DefaultLayout>{body}</DefaultLayout>;
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:tag:list"));
    const { setDelData } = useAppContext();

    if (!apiData) return;

    const headerTools = (
        <Link to={url_reverse("admin:tag:edit", { tag_id: "add" })} className="btn btn-sm btn-dark">
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("Название для URL")}</th>
                        <th>{t("Дата")}</th>
                        <th>{t("Публикация")}</th>
                        <th />
                        <th style={{ width: "6%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>
                                    <Link to={url_reverse("admin:tag:edit", { tag_id: o.id })}>
                                        {o.__model_locale_object.name}
                                    </Link>
                                </td>
                                <td>{o.slug}</td>
                                <td>{o.date_added}</td>
                                <td>
                                    <YesNoColumn attr={o.is_published} />
                                </td>
                                <td>
                                    <Link to={url_reverse("admin:tag:games", { tag_id: o.id })}>{t("Игры")}</Link>
                                    {" | "}
                                    <Link to={url_reverse("admin:tag:countries", { tag_id: o.id })}>{t("Страны")}</Link>
                                </td>
                                <td className="dmg-table-row-tools">
                                    <Link to={url_reverse("admin:tag:countries", { tag_id: o.id })}>
                                        <Awesome type="flag" />
                                    </Link>{" "}
                                    <Awesome
                                        type="trash-o"
                                        color="red"
                                        onClick={() =>
                                            setDelData({ url: url_reverse("api:tag:delete", { tag_id: o.id }) })
                                        }
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:tag:edit", { tag_id: id }));
    const onFormSubmit = useSubmit();

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <Form onSubmit={(ev) => onFormSubmit(ev, { backUrl: url_reverse("admin:tag:list") })}>
                <RenderForm bareForm={true} />
                {Object.keys(apiData.forms_data || {}).map((prefix) => {
                    return prefix !== "main" && <RenderForm key={prefix} prefix={prefix} bareForm={true} />;
                })}
                <DevForm.Button variant="primary" type="submit" name="save">
                    {t("Сохранить")}
                </DevForm.Button>
            </Form>
        </CommonCard>
    );
}

function Games({ id, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:tag:games", { tag_id: id }));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Игра")}</th>
                        <th>{t("Дата")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>
                                    <Link to={url_reverse("games:admin", { game_id: o.game_id })}>
                                        {o.game.base_locale_object.name}
                                    </Link>
                                </td>
                                <td>{o.date_added}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Countries({ id, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(url_reverse("api:tag:countries", { tag_id: id }));
    const onFormSubmit = useSubmit();

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <CountriesPresets
                apiData={apiData}
                setApiData={setApiData}
                getPresetData={(data) => data.preset}
                prefix="main"
            />
            <hr />
            <Form onSubmit={onFormSubmit}>
                <CountriesBareForm apiData={apiData} setApiData={setApiData} />
                <DevForm.Button variant="primary" type="submit" className="mt-3" name="save">
                    {t("Сохранить")}
                </DevForm.Button>
            </Form>
        </CommonCard>
    );
}
